import {
  errorIndicatesMaxMfaRetries,
  errorIndicatesMfaTimeout,
  errorIndicatesMfaVerificationFailed,
} from '@privy-io/react-auth';

import { type WalletMfaError, WalletMfaErrorKind } from './wallet-mfa-types';

export { WalletMfaErrorKind } from './wallet-mfa-types';

export class WalletMfaVerificationCancelledError extends Error {
  constructor() {
    super('Wallet confirmation was cancelled.');
    this.name = 'WalletMfaVerificationCancelledError';
  }
}

export const isWalletMfaVerificationCancelled = (
  error: unknown,
): error is WalletMfaVerificationCancelledError =>
  error instanceof WalletMfaVerificationCancelledError;

export const classifyWalletMfaError = (error: unknown): WalletMfaError => {
  if (errorIndicatesMfaVerificationFailed(error)) {
    return {
      kind: WalletMfaErrorKind.InvalidCode,
      message: 'Incorrect code. Please try again.',
    };
  }

  if (errorIndicatesMfaTimeout(error)) {
    return {
      kind: WalletMfaErrorKind.Timeout,
      message: 'Confirmation expired. Start again.',
    };
  }

  if (errorIndicatesMaxMfaRetries(error)) {
    return {
      kind: WalletMfaErrorKind.MaxAttempts,
      message: 'Too many attempts. Wait a moment and try again.',
    };
  }

  return {
    kind: WalletMfaErrorKind.Unknown,
    message: 'Wallet confirmation could not be completed. Please try again.',
  };
};
